<template>
  <v-container style="background-color: white" fluid>
    <v-tabs v-model="selectedTab" slider-color="#E07353">
      <v-tab>ХИЧЭЭЛЭЭР</v-tab>
      <v-tab>СУРАЛЦАГЧААР </v-tab>
      <v-tab>НЭГТГЭЛ</v-tab>
      <v-tab>ХИЧЭЭЛИЙН ДҮН ТАТАХ</v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item>
        <v-progress-linear
          v-if="loading || !lessons || lessons.length == 0"
          color="red"
          height="6"
          indeterminate
        ></v-progress-linear>
        <v-data-table
          v-if="lessons && renderComponent"
          :headers="headers"
          :items="lessons"
          class="elevation-1"
          dense
          hide-details
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Хичээл</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          :headers="headers2"
          :items="students"
          class="elevation-1"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Суралцагчийн мэдээлэл</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table></v-tab-item
      >
      <v-tab-item> 3 </v-tab-item>
      <v-tab-item class="py-10">
        <v-btn class="mt-4 mr-4" outlined> Xичээл татаx </v-btn>
        <v-btn class="mt-4 bg-gradient-success" dark> Дүн оруулаx </v-btn>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
export default {
  data() {
    return {
      selectedTab: 0,
      headers: [
        { text: "No", value: "index", align: "start" },
        {
          text: "Хичээл",
          value: "courseInfo.COURSE_NAME",
          align: "start",
        },
        { text: "Төрөл", value: "courseInfo.ENROLLMENT_CATEGORY_NAME" },
        { text: "Нийт судалсан", value: "totalStudied" },
        { text: "Дүн батлагдсан", value: "gradeApproved" },
        { text: "Дүн бүртгэсэн", value: "gradeRegistered" },
        { text: "Хянагдаж байгаа", value: "underReview" },
        { text: "Дүн цуцлагдсан", value: "gradeCancelled" },
      ],
      courses: [
        {
          name: "Монгол хэл 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Үндэсний бичиг 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Уран зохиол 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Математик 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Мэдээллийн технологи 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Англи хэл 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Орос хэл 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Биеийн тамир 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Эрүүл мэнд 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
        {
          name: "Дизайн/зураг зүй, технологи 12",
          type: "Заавал",
          totalStudied: 0,
          gradeApproved: 0,
          gradeRegistered: 0,
          underReview: 0,
          gradeCancelled: 0,
        },
      ],

      headers2: [
        { text: "Суралцагч", value: "student", align: "start" },
        { text: "Регистр", value: "register" },
        { text: "Нийт судалсан", value: "totalStudied" },
        { text: "Дүн батлагдсан", value: "gradeApproved" },
        { text: "Дүн бүртгэсэн", value: "gradeRegistered" },
        { text: "Хянагдаж байгаа", value: "underReview" },
        { text: "Дүн цуцлагдсан", value: "gradeCancelled" },
      ],
      students: [
        {
          student: "Н.Бархасвад",
          register: "ме07322714",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "М.Ванчир-Эрдэнэ",
          register: "ме07241811",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Б.Гансух",
          register: "ру07272316",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "У.Жавхлан",
          register: "тя07252311",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Э.Мичидмаа",
          register: "ме07231700",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Д.Мягмарсүх",
          register: "ме07280709",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Т.Мөнхтулга",
          register: "ме07312717",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Б.Мөнхцэцэг",
          register: "ме07292605",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Н.Мөрөн",
          register: "ме07292514",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Э.Нандин-Эрдэнэ",
          register: "ме07222604",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
      ],

      selectedProgram: null,
      lessons: null,
      selectedHalfYearId: 1,
      selectedHalfYear: null,
      halfYear2Date: null,
      halfYearDate: null,
      loading: false,
      renderComponent: true,
    };
  },
  props: {
    selectedClassGroup: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    readLessons() {
      this.userData.school.ref
        .collection("lessons-" + this.userData.school.currentYear)
        .where("classGroupRefs", "array-contains", this.selectedProgram.ref)
        .orderBy("courseInfo.COURSE_NAME", "asc")
        .onSnapshot((docs) => {
          this.lessons = [];
          // var electiveLessonNumber = 0;
          // var mandatoryLessonNumber = 0;
          docs.forEach(async (doc) => {
            let lesson = doc.data();
            lesson.ref = doc.ref;
            lesson.id = doc.id;

            if (!lesson.deleted) {
              // if (lesson.courseInfo.ENROLLMENT_CATEGORY == "MANDATORY") {
              //   mandatoryLessonNumber++;
              // } else {
              //   electiveLessonNumber++;
              // }

              // lesson.students = this.selectedProgram.students;

              this.isThisSemesterLesson(lesson);
              if (!lesson.isNotThisSemester) {

                lesson.courseInfo.ENROLLMENT_CATEGORY_NAME =
                  lesson.courseInfo.ENROLLMENT_CATEGORY_NAME.replace(
                    "судлах",
                    ""
                  );

                if (
                  this.selectedProgram[
                    "year" + this.selectedHalfYear.yearId + "UnelgeeScores"
                  ][lesson.id]
                ) {
                  var tmp =
                    this.selectedProgram[
                      "year" + this.selectedHalfYear.yearId + "UnelgeeScores"
                    ][lesson.id];
                  lesson.totalStudied = tmp.numberStudentsOfUnelgee
                    ? tmp.numberStudentsOfUnelgee
                    : 0;
                  lesson.gradeApproved = tmp.approvedNumber
                    ? tmp.approvedNumber
                    : 0;
                  lesson.gradeRegistered = tmp.savedNumber
                    ? tmp.savedNumber
                    : 0;
                  lesson.underReview = tmp.inProgressNumber
                    ? tmp.inProgressNumber
                    : 0;
                  lesson.gradeCancelled = tmp.rejectedNumber
                    ? tmp.rejectedNumber
                    : 0;

                  if (lesson.totalStudied < lesson.gradeApproved) {
                    lesson.gradeApproved = lesson.totalStudied;
                  }
                  if (lesson.totalStudied < lesson.gradeRegistered) {
                    lesson.gradeRegistered = lesson.totalStudied;
                  }
                  if (lesson.totalStudied < lesson.underReview) {
                    lesson.underReview = lesson.totalStudied;
                  }
                  if (lesson.totalStudied < lesson.gradeCancelled) {
                    lesson.gradeCancelled = lesson.totalStudied;
                  }
                }

                this.lessons.push(lesson);
              }
            }
          });

          // if (!this.lessonNumberSetupped) {
          //   var tmp = {};
          //   tmp["year" + this.selectedHalfYearId + "UnelgeeScores"] = this
          //     .selectedProgram[
          //     "year" + this.selectedHalfYearId + "UnelgeeScores"
          //   ]
          //     ? this.selectedProgram[
          //         "year" + this.selectedHalfYearId + "UnelgeeScores"
          //       ]
          //     : {};
          //   tmp[
          //     "year" + this.selectedHalfYearId + "UnelgeeScores"
          //   ].mandatoryLessonNumber = mandatoryLessonNumber;

          //   tmp[
          //     "year" + this.selectedHalfYearId + "UnelgeeScores"
          //   ].electiveLessonNumber = electiveLessonNumber;

          //   this.selectedProgram.ref.update(tmp);
          //   this.lessonNumberSetupped = true;
          // }

          this.lessons = this.lessons
            .sort(
              (a, b) =>
                a.courseInfo.SUBJECT_AREA_ID - b.courseInfo.SUBJECT_AREA_ID
            )
            .sort(
              (a, b) =>
                b.courseInfo.ENROLLMENT_CATEGORY.length -
                a.courseInfo.ENROLLMENT_CATEGORY.length
            );
          this.loading = false;

          var index = 1;
          this.lessons.forEach((lsn) => {
            lsn.index = index;
            index++;
          });

          this.forceRerender();
        });
    },
    isThisSemesterLesson(lesson) {
      if (lesson) {
        if (this.selectedHalfYear.yearId > 1) {
          if (
            (lesson.startEnd["semester-2"] &&
              lesson.startEnd["semester-2"].available) ||
            (lesson.startEnd["semester-3"] &&
              lesson.startEnd["semester-3"].available)
          ) {
            lesson.isNotThisSemester = false;
          } else {
            lesson.isNotThisSemester = true;
          }
        } else {
          if (
            lesson.startEnd["semester-1"] &&
            lesson.startEnd["semester-1"].available
          ) {
            lesson.isNotThisSemester = false;
          } else {
            lesson.isNotThisSemester = true;
          }
        }
      }
    },
    _setupp() {
      this.loading = true;
      this.lessons = null;
      this.selectedProgram = Object.assign({}, this.selectedClassGroup);
      this.selectedHalfYear = {
        yearId: Number(this.selectedHalfYearId),
        name: this.preText + " xичээлийн жил, 1-р xагас жил",
      };
      this.userData.school.ref
        .collection("students-" + this.userData.school.currentYear)
        .where(
          "STUDENT_GROUP_ID",
          "==",
          Number(this.selectedProgram.STUDENT_GROUP_ID)
        )
        .get()
        .then((docs) => {
          this.selectedProgram.students = [];
          console.log(docs.size, this.selectedHalfYear.yearId);
          docs.forEach((doc) => {
            let student = doc.data();
            student.ref = doc.ref;
            student.id = doc.id;
            if (this.selectedHalfYear.yearId == 1) {
              if (
                !student.ACTION_DATE ||
                new Date(student.ACTION_DATE) <= this.halfYearDate
              ) {
                if (!student.moved) {
                  this.selectedProgram.students.push(student);
                }
              }
            } else {
              if (
                !student.ACTION_DATE ||
                new Date(student.ACTION_DATE) <= this.halfYear2Date
              ) {
                if (!student.moved) {
                  this.selectedProgram.students.push(student);
                }
              }
            }
            // if (!student.moved) prog.students.push(student);
          });
          console.log(this.selectedProgram);
          if (!this.lessons) this.readLessons();
        });
    },
  },
  created() {
    this.halfYearDate = new Date(
      this.$store.state.calendarButez2[0].months[
        this.$store.state.calendarButez2[0].months.length - 1
      ].days[
        this.$store.state.calendarButez2[0].months[
          this.$store.state.calendarButez2[0].months.length - 1
        ].days.length - 1
      ].year +
        "-" +
        this.$store.state.calendarButez2[0].months[
          this.$store.state.calendarButez2[0].months.length - 1
        ].name +
        "-" +
        this.$store.state.calendarButez2[0].months[
          this.$store.state.calendarButez2[0].months.length - 1
        ].days[
          this.$store.state.calendarButez2[0].months[
            this.$store.state.calendarButez2[0].months.length - 1
          ].days.length - 1
        ].day
    );
    this.halfYear2Date = new Date(
      this.$store.state.calendarButez2[2].months[0].days[0].year +
        "-" +
        this.$store.state.calendarButez2[2].months[
          this.$store.state.calendarButez2[2].months.length - 1
        ].name +
        "-" +
        this.$store.state.calendarButez2[2].months[
          this.$store.state.calendarButez2[2].months.length - 1
        ].days[
          this.$store.state.calendarButez2[2].months[
            this.$store.state.calendarButez2[2].months.length - 1
          ].days.length - 1
        ].day
    );
    this.preText =
      this.userData.school.currentYear +
      "-" +
      this.userData.school.currentYear +
      1;

    this._setupp();
    console.log(this.selectedClassGroup);
  },
};
</script>
